var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scopeList && _vm.scopeList.length)?_c('div',{staticClass:"vuw-scope-list"},[_c('checkbox-list',{attrs:{"filters":_vm.scopeList},on:{"filterChanged":_vm.setActiveScope}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }